import { Patient } from 'types/types';
import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';
import { normalizePatient } from 'modules/patients/utils/normalizePatient';

export const translatePatient = (rawPatient: object): Patient =>
  normalizePatient(convertSnakeToCamelCase(rawPatient));
